// extracted by mini-css-extract-plugin
module.exports = {"vRed4":"#ff4e1f","line":"CalendarDayTimeLine_line__3VZ6D"};